// @flow
import React, {useCallback} from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import { withRouter } from 'react-router-dom';
import { TableRow, TableRowColumn } from 'material-ui/Table';
import { ActionCell } from "./columns/actions";

const InfoStringListItem = (props) => {
	const { history, item, viewer } = props;

	const redirect = useCallback(() => history.push(`/info-strings/${item.id}`), [history]);

	return (
		<TableRow
			onClick={redirect}
			style={{ border: 0 }}
		>
			<TableRowColumn className="table--cell table--cell-body">{item.title}</TableRowColumn>
			<TableRowColumn className="table--cell table--cell-body">
				<ActionCell {...item} />
			</TableRowColumn>
		</TableRow>
	);
};

export default withRouter(createFragmentContainer(InfoStringListItem, {
	item: graphql`
		fragment InfoStringListItem_item on InfoString {
			id
			title
			order
			infostring
			infostring_hot
		}
	`,
}));



// WEBPACK FOOTER //
// src/components/info-strings/InfoStringListItem.js